// extracted by mini-css-extract-plugin
export var deliveryRow = "_o0-a";
export var fixedHeight = "_o0-4";
export var freightLogo = "_o0-9";
export var fullWidth = "_o0-3";
export var priceColumn = "_o0-5";
export var radioSelected = "_o0-7";
export var radioUnselected = "_o0-6";
export var selectedOption = "_o0-2";
export var selectedOptionContainer = "_o0-1";
export var selection = "_o0-0";
export var tallSkeletonText = "_o0-8";